var dimensionsAreValid = false;
var lastValidWidth = 0;
var lastValidHeight = 0;
var dimensionsUserInteracted = false;
  var popup = document.querySelector('.popup');
    var closeBtn = document.querySelector('.close-btn');
    var customizeAndBuy = document.querySelector('.customize_and_buy');
    var productJson = JSON.parse(document.getElementById('product-json').textContent);
    var productMetaJson = JSON.parse(document.getElementById('product-meta-json').textContent);
    var sampleProductsJson = JSON.parse(document.getElementById('sampleProducts-json').textContent);
    var metaImage = document.querySelector('#chartContainer');
    var metaImageScroll = document.querySelector('#chartContainer-scroll');
    var moneyFormat = document.querySelector('body').getAttribute("data-money-format");
    var widthInput = document.querySelector('#width_in_inches');
    var heightInput = document.querySelector('#height_in_inches');
    var MIN_SQFT = parseFloat(widthInput.dataset.minSqft) || 12;
    var addToCart = document.querySelector('#ms_sp_addto_cart');
    var addToCartOriginalHTML = addToCart.innerHTML;
    var ADD_TO_CART_EMPTY_TEXT = 'Enter wall size to see price';
    var sizeAlert = document.querySelector('.walltool-size-alert');
    var addToCartMain = document.querySelector('.ms_sp_main');
    var buySampleProducts = document.querySelector('.buy_sample_products');
    var wallpaperSizeRadio = document.querySelectorAll('[name="wallpaper-size"]');
    var selectedDesign =  document.querySelector('#selected-design');
    var loaderWall = document.querySelector('.loader-wall');
    // var propertiesWallpaperSize =  document.querySelector('#properties-wallpaper-size');
    var propertiesDimension = document.querySelector('#properties-dimension');
    var chartContainerMain = document.querySelector('#chartContainer-main');
    var product_image = document.querySelector('#product_image');

    var price_main  = document.querySelector('.product-price-container .no-js-hidden');
    var order_sample_btn  = document.querySelector('.order_sample_products');
    var price_roll  = document.querySelector('.product-price-js');
    var roll_select = document.querySelector('.variant-selector-js');

    var SALE_PERCENTAGE = parseFloat(document.querySelector('.product-price-js').getAttribute('data-sale-percentage')) || 0;
    var SAMPLE_BUNDLE_DISCOUNT_PERCENT = 70;


    var propertiesPanelWidth = document.querySelector('#properties-panel-width');
    var switch_input = document.querySelector('.switch-input');
    var strips_text = document.querySelector('.strips-text');
    var cropper = null;
    var cropperUserPositioned = false;
    var panelWidth = document.getElementById("panelWidth");
    var panelWidthValue = document.getElementById("panelWidthValue");
    panelWidthValue.innerHTML = panelWidth.value+' inches';
    panelWidth.oninput = function() {
        var brd_bx = document.querySelectorAll('.brd_bx');
        panelWidthValue.innerHTML = this.value+' inches';
        propertiesPanelWidth.value = this.value+' inches';
        const panelWidthInput = this.value * 1;
        const totalWidthInput = widthInput.value * 1;
        const percentage = (panelWidthInput / totalWidthInput) * 100;
        brd_bx.forEach(function(element) {
            element.style.minWidth = percentage+'%';
        });
    }
    switch_input.addEventListener('change', function() {
      if (!cropper) return;
      calculatePanels();
      var brdr_cntr = document.querySelector('.brdr_cntr');
      if (switch_input.checked) {
          appendChildCrop();
          brdr_cntr = document.querySelector('.brdr_cntr');
          if (brdr_cntr) brdr_cntr.style.display = 'flex';
      } else {
          if (brdr_cntr) brdr_cntr.style.display = 'none';
      }
  });

  var buySampleProductsOriginalHTML = buySampleProducts.innerHTML;
  function setBuySampleButtonText(text) {
    var textSpan = buySampleProducts.querySelector('span:not(.loading-overlay)');
    if (textSpan) {
      textSpan.textContent = text;
    } else {
      buySampleProducts.innerHTML = buySampleProductsOriginalHTML;
      var restoredSpan = buySampleProducts.querySelector('span:not(.loading-overlay)');
      if (restoredSpan) restoredSpan.textContent = text;
    }
  }

  function formatMoneySmart(cents) {
      var formatted = Shopify.formatMoney(cents, moneyFormat);
      if (cents % 100 === 0) {
          formatted = formatted.replace(/([.,])00(?=\D*$)/, '');
      }
      return formatted;
  }

  function applySalePricing(originalCents) {
    if (!SALE_PERCENTAGE || SALE_PERCENTAGE <= 0) {
        return { hasSale: false, original: originalCents, sale: originalCents };
    }
    var saleCents = Math.round(originalCents * (1 - (SALE_PERCENTAGE / 100)));
    return { hasSale: true, original: originalCents, sale: saleCents };
}
 
function renderSalePriceHTML(originalCents, suffixHTML) {
    suffixHTML = suffixHTML || '';
    var pricing = applySalePricing(originalCents);
    if (pricing.hasSale) {
        return '<span class="sale-original-price">' + formatMoneySmart(pricing.original) + '</span> ' +
               '<span class="sale-discounted-price">' + formatMoneySmart(pricing.sale) + '</span>' + suffixHTML;
    }
    return formatMoneySmart(pricing.original) + suffixHTML;
}

// ================= MATERIAL BOOK ADD-ON (Task 1) =================
var materialBookBtn = document.querySelector('#materialBookToggleBtn');
var materialBookVariantId = materialBookBtn ? parseInt(materialBookBtn.dataset.variantId, 10) : null;
var materialBookPriceCents = materialBookBtn ? parseInt(materialBookBtn.dataset.price, 10) : 0;
var materialBookAddText = materialBookBtn ? materialBookBtn.dataset.addText : 'Add';
var materialBookAdded = false;
var materialBookLineKey = null;
 
function resetMaterialBookState() {
    materialBookAdded = false;
    materialBookLineKey = null;
    updateMaterialBookButtonText();
    updateDrawerAddToCartButtonText();
}
 
function updateMaterialBookButtonText() {
    if (!materialBookBtn) return;
    if (materialBookAdded) {
        materialBookBtn.innerHTML = '✓ SELECTED · +' + formatMoneySmart(materialBookPriceCents);
        materialBookBtn.classList.add('is-added');
    } else {
        materialBookBtn.innerHTML = materialBookAddText;
        materialBookBtn.classList.remove('is-added');
    }
}

function getSampleMultiselectWrap() {
    return document.querySelector('.orderSample-drawer [data-sample-multiselect]');
}

function getSelectedSampleSwatches(wrap) {
    if (!wrap) return [];
    return Array.prototype.slice.call(wrap.querySelectorAll('[data-sample-swatch][aria-pressed="true"]'));
}

function clearSampleSelection() {
    var wrap = getSampleMultiselectWrap();
    if (!wrap) return;
    wrap.querySelectorAll('[data-sample-swatch][aria-pressed="true"]').forEach(function(btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('is-selected');
    });
}
 
function updateDrawerAddToCartButtonText() {
    if (!drawerAddToCartBtn) return;
    var wrap = getSampleMultiselectWrap();
    var selected = getSelectedSampleSwatches(wrap);

    var prices = [];
    selected.forEach(function(btn) {
        var price = parseInt(btn.getAttribute('data-price'), 10);
        if (!isNaN(price)) prices.push(price);
    });

    var originalCents = 0;
    var discountedCents = 0;
    if (prices.length) {
        prices.sort(function(a, b) { return b - a; });
        originalCents += prices[0];
        discountedCents += prices[0];
        for (var i = 1; i < prices.length; i++) {
            originalCents += prices[i];
            discountedCents += Math.round(prices[i] * (100 - SAMPLE_BUNDLE_DISCOUNT_PERCENT) / 100);
        }
    }

    if (materialBookAdded) {
        originalCents += materialBookPriceCents;
        discountedCents += materialBookPriceCents;
    }

    if (selected.length === 0) {
        drawerAddToCartBtn.disabled = true;
        drawerAddToCartBtn.innerHTML = 'Select a sample';
        return;
    }

    drawerAddToCartBtn.disabled = false;

    if (prices.length > 1) {
        drawerAddToCartBtn.innerHTML =
            'Add To Cart &nbsp;|&nbsp; <s class="sample-price-original">' + formatMoneySmart(originalCents) + '</s> ' + formatMoneySmart(discountedCents);
    } else {
        drawerAddToCartBtn.innerHTML = 'Add To Cart &nbsp;|&nbsp; ' + formatMoneySmart(discountedCents);
    }
}
 
if (materialBookBtn) {
    materialBookBtn.addEventListener('click', function() {
        materialBookAdded = !materialBookAdded;
        updateMaterialBookButtonText();
        updateDrawerAddToCartButtonText();
    });
}
 
var materialBookPoster = document.querySelector('#materialBookPoster');
var materialBookPlayBtn = document.querySelector('#materialBookPlayBtn');
var materialBookVideo = document.querySelector('#materialBookVideo');
if (materialBookPlayBtn && materialBookVideo && materialBookPoster) {
    materialBookPlayBtn.addEventListener('click', function() {
        materialBookPoster.style.display = 'none';
        materialBookPlayBtn.style.display = 'none';
        materialBookVideo.style.display = 'block';
        materialBookVideo.muted = false;
        materialBookVideo.play();
    });
}
 
// ================= TOAST POPUP (replaces cart drawer open) =================
var sampleAddedToast = document.querySelector('#sampleAddedToast');
var sampleAddedToastText = document.querySelector('#sampleAddedToastText');
var sampleAddedToastTimer = null;
 
function showSampleAddedToast(sampleName) {
    if (!sampleAddedToast || !sampleAddedToastText) return;
    sampleAddedToastText.innerHTML = 'A sample of \'' + sampleName + '\' has been added to your cart ';
    sampleAddedToast.classList.add('is-visible');
    clearTimeout(sampleAddedToastTimer);
    sampleAddedToastTimer = setTimeout(function() {
        sampleAddedToast.classList.remove('is-visible');
    }, 5000);
}

  
    function panelWidthPercentage(){
        var brd_bx = document.querySelectorAll('.brd_bx');
        const panelWidthInput = panelWidth.value * 1;
        const totalWidthInput = widthInput.value * 1;
        const percentage = (panelWidthInput / totalWidthInput) * 100;
        brd_bx.forEach(function(element) {
        element.style.minWidth = percentage+'%';
        });
    }

    function appendChildCrop() {
    var cropperCropBox = document.querySelector('.cropper-crop-box');
    var brdrCntr = document.querySelector('.brdr_cntr');
    
    if (!brdrCntr && cropperCropBox) {
      brdrCntr = document.createElement('div');
      brdrCntr.className = 'brdr_cntr';
      //brdrCntr.style.display = 'none';
    
      for (var i = 0; i < 40; i++) {
        var brdBx = document.createElement('div');
        brdBx.className = 'brd_bx';
        brdrCntr.appendChild(brdBx);
      }
    cropperCropBox.appendChild(brdrCntr);
    panelWidthPercentage(); 
    }
    }

    const apikey = 'AlJbPCQiRQ6xnukQkEr2wz';
    const client = filestack.init(apikey);
    const token = {}; 
    

	$('.close-btn').on('click', function() {
		$('body').removeClass('open-cc');
		$('.popup').removeClass('open');
	});


    window.addEventListener('click', function(event) {
    	if (event.target == popup) {
			$('body').removeClass('open-cc');
    		$('.popup').removeClass('open');
    	}
    });


function initializeCropper(imageElement) {
    var cropper = new Cropper(imageElement, {
        cropBoxResizable: false,
        zoomable: false
    });
    imageElement.addEventListener('cropend', function() {
        cropperUserPositioned = true;
    });
    return cropper;
}
    function setAspectRatio(cropper, widthInInches, heightInInches) {
    cropper.setAspectRatio(widthInInches / heightInInches);
    }


    function openPopup() {
    metaImage.classList.add('crop-hide');
    $('body').addClass('open-cc');
		$('.popup').addClass('open');
    var imgSrc = '';
    var id  = parseInt(document.querySelector('[name="id"]').value);
    Object.keys(productMetaJson).forEach(function(key) {
    if(productMetaJson[key].variant_id == id){
    imgSrc = productMetaJson[key].img;
    }
    });
    metaImage.innerHTML = '';
    var img = document.createElement("img");
    img.src = imgSrc;
    metaImage.appendChild(img);
    var imageElement = document.querySelector('#chartContainer img');
    cropper = initializeCropper(imageElement);
    cropperUserPositioned = false;
    }


    
    function convertToSquareMeters(widthInInches, heightInInches) {
    var squareFoot = (heightInInches * widthInInches) / 144;
    var roundedNumber = Math.ceil(squareFoot);
    return roundedNumber;
    }

// ✅ Shared helper — show/hide ALL instances of width/height error divs on page
function setWidthError(show) {
    document.querySelectorAll('.ResizePanel-widthError').forEach(function(el) {
        el.style.display = show ? 'flex' : 'none';
    });
}
function setHeightError(show) {
    document.querySelectorAll('.ResizePanel-heightError').forEach(function(el) {
        el.style.display = show ? 'flex' : 'none';
    });
}

function updatePricingAndProperties(widthInInches, heightInInches, squareFoot) {
    var id = parseInt(document.querySelector('[name="id"]').value);

    const unit = $(".unit-selector:not(.read-select)").first().val();
    let widthDisplay, heightDisplay;
    if (unit === "ft/in") {
        const wFt = Math.floor(widthInInches / 12);
        const wIn = parseFloat((widthInInches % 12).toFixed(2));
        const hFt = Math.floor(heightInInches / 12);
        const hIn = parseFloat((heightInInches % 12).toFixed(2));
        widthDisplay  = wIn > 0 ? `${wFt} ft ${wIn} in` : `${wFt} ft`;
        heightDisplay = hIn > 0 ? `${hFt} ft ${hIn} in` : `${hFt} ft`;
    } else if (unit === "cm") {
        widthDisplay  = parseFloat((widthInInches * 2.54).toFixed(2)) + ' cm';
        heightDisplay = parseFloat((heightInInches * 2.54).toFixed(2)) + ' cm';
    } else if (unit === "m") {
        widthDisplay  = parseFloat((widthInInches * 0.0254).toFixed(2)) + ' m';
        heightDisplay = parseFloat((heightInInches * 0.0254).toFixed(2)) + ' m';
    } else {
        widthDisplay  = widthInInches + ' in';
        heightDisplay = heightInInches + ' in';
    }

    propertiesDimension.value = 'W: ' + widthDisplay + ' x H: ' + heightDisplay + ' (' + squareFoot + ' sq ft)';

    Object.keys(productJson).forEach(function(key) {
        if (productJson[key].id === id) {
            var productProperties = productJson[key].price;
            var newPrice = productProperties * squareFoot;
            document.getElementById('properties-set').value = squareFoot;
            document.querySelector('.product_properties span').innerHTML = formatMoneySmart(productProperties);
            document.querySelector('[name="quantity"]').value = squareFoot;
            $('.m2').html(squareFoot);
            $('.product_pricing').html(renderSalePriceHTML(newPrice));
        }
    });
}

function saveDimensionsToStorage(widthInInches, heightInInches, unit) {
    var data = {
        width: widthInInches,
        height: heightInInches,
        unit: unit,
        timestamp: Date.now()
    };
    localStorage.setItem("wallTool_savedDimensions", JSON.stringify(data));
}

function getSavedDimensions() {
    var raw = localStorage.getItem("wallTool_savedDimensions");
    if (!raw) return null;

    var data;
    try {
        data = JSON.parse(raw);
    } catch (e) {
        localStorage.removeItem("wallTool_savedDimensions");
        return null;
    }

    var ONE_DAY_MS = 24 * 60 * 60 * 1000;
    var isExpired = !data.timestamp || (Date.now() - data.timestamp) > ONE_DAY_MS;
    if (isExpired) {
        localStorage.removeItem("wallTool_savedDimensions");
        return null;
    }

    return data; // { width, height, unit, timestamp }
}

function changeTheDimensions() {
    var widthMax  = parseFloat(widthInput.getAttribute("max"))  || null;
    var heightMax = parseFloat(heightInput.getAttribute("max")) || null;
    var minSqft   = MIN_SQFT;

    var widthInInches  = parseFloat(widthInput.value);
    var heightInInches = parseFloat(heightInput.value);

    var pageWidthCol  = document.querySelector('#preview_width_ft')?.closest('.dimenion-grid-col');
    var pageHeightCol = document.querySelector('#preview_height_ft')?.closest('.dimenion-grid-col');

    var hasValidNumbers = !isNaN(widthInInches) && !isNaN(heightInInches) && widthInInches > 0 && heightInInches > 0;

    if (!hasValidNumbers) {
        dimensionsAreValid = false;
        addToCart.disabled = true;
        sizeAlert.style.display = 'none';
        setWidthError(false);
        setHeightError(false);
        widthInput.closest(".span_1_of_2").classList.remove("error");
        heightInput.closest(".span_1_of_2").classList.remove("error");
        if (pageWidthCol)  pageWidthCol.classList.remove("error");
        if (pageHeightCol) pageHeightCol.classList.remove("error");

        if (lastValidWidth > 0 && lastValidHeight > 0) {
            var _saved = dimensionsAreValid;
            dimensionsAreValid = true;
            backgroundRepete(lastValidWidth, lastValidHeight);
            dimensionsAreValid = false;

            const unit = $(".unit-selector:not(.read-select)").first().val();
            let widthLabel, heightLabel;
            if (unit === "ft/in") {
                const wFt = Math.floor(lastValidWidth / 12);
                const wIn = parseFloat((lastValidWidth % 12).toFixed(2));
                const hFt = Math.floor(lastValidHeight / 12);
                const hIn = parseFloat((lastValidHeight % 12).toFixed(2));
                widthLabel  = wIn > 0 ? `${wFt} ft ${wIn} in` : `${wFt} ft`;
                heightLabel = hIn > 0 ? `${hFt} ft ${hIn} in` : `${hFt} ft`;
            } else if (unit === "cm") {
                widthLabel  = parseFloat((lastValidWidth  * 2.54).toFixed(2)) + ' cm';
                heightLabel = parseFloat((lastValidHeight * 2.54).toFixed(2)) + ' cm';
            } else if (unit === "m") {
                widthLabel  = parseFloat((lastValidWidth  * 0.0254).toFixed(2)) + ' m';
                heightLabel = parseFloat((lastValidHeight * 0.0254).toFixed(2)) + ' m';
            } else {
                widthLabel  = lastValidWidth  + ' in';
                heightLabel = lastValidHeight + ' in';
            }
            $('.walltool-canvas-width span').text(widthLabel);
            $('.walltool-canvas-height span').text(heightLabel);
            $('.sixe__info').text(`${widthLabel} x ${heightLabel}`);
        }

        var id = parseInt(document.querySelector('[name="id"]').value);
        Object.keys(productJson).forEach(function(key) {
            if (productJson[key].id === id) {
                var minOrderPrice = productJson[key].price * minSqft;
                $('.product_pricing').html('Min order: ' + renderSalePriceHTML(minOrderPrice));
            }
        });
        $('.atc-suffix').hide();
        return;
    }

    // ✅ Evaluate width-max and height-max INDEPENDENTLY — each only reacts to its own value
    var overWidthMax  = widthMax  ? widthInInches  > widthMax  : false;
    var overHeightMax = heightMax ? heightInInches > heightMax : false;

    setWidthError(overWidthMax);
    widthInput.closest(".span_1_of_2").classList.toggle("error", overWidthMax);
    if (pageWidthCol) pageWidthCol.classList.toggle("error", overWidthMax);

    setHeightError(overHeightMax);
    heightInput.closest(".span_1_of_2").classList.toggle("error", overHeightMax);
    if (pageHeightCol) pageHeightCol.classList.toggle("error", overHeightMax);

    if (overWidthMax || overHeightMax) {
        dimensionsAreValid = false;
        addToCart.disabled = true;
        sizeAlert.style.display = 'none';
        $('.atc-suffix').hide();

        var id = parseInt(document.querySelector('[name="id"]').value);
        Object.keys(productJson).forEach(function(key) {
            if (productJson[key].id === id) {
                var minOrderPrice = productJson[key].price * minSqft;
                $('.product_pricing').html('Min order: ' + renderSalePriceHTML(minOrderPrice));
            }
        });
        return;
    }

    dimensionsAreValid = true;
    lastValidWidth  = widthInInches;
    lastValidHeight = heightInInches;

    var currentUnit = $(".unit-selector:not(.read-select)").first().val();
    saveDimensionsToStorage(widthInInches, heightInInches, currentUnit);

    calculatePanels();

    var id = parseInt(document.querySelector('[name="id"]').value);
    var maxSquareFoot = parseFloat(widthInput.getAttribute("data"));
    var squareFoot    = convertToSquareMeters(widthInInches, heightInInches);
    var overMax       = maxSquareFoot ? squareFoot > maxSquareFoot : false;
    var belowMinOrder = squareFoot < minSqft;

    sizeAlert.style.display = overMax ? 'block' : 'none';
    backgroundRepete(widthInInches, heightInInches);

    if (belowMinOrder) {
        Object.keys(productJson).forEach(function(key) {
            if (productJson[key].id === id) {
                var minOrderPrice = productJson[key].price * minSqft;
                $('.product_pricing').html('Min order: ' + renderSalePriceHTML(minOrderPrice));
            }
        });
        $('.atc-suffix').hide();
    } else {
        let widthDisplay, heightDisplay;
        if (currentUnit === "ft/in") {
            const wFt = Math.floor(widthInInches / 12);
            const wIn = parseFloat((widthInInches % 12).toFixed(2));
            const hFt = Math.floor(heightInInches / 12);
            const hIn = parseFloat((heightInInches % 12).toFixed(2));
            widthDisplay  = wIn > 0 ? `${wFt} ft ${wIn} in` : `${wFt} ft`;
            heightDisplay = hIn > 0 ? `${hFt} ft ${hIn} in` : `${hFt} ft`;
        } else if (currentUnit === "cm") {
            widthDisplay  = parseFloat((widthInInches * 2.54).toFixed(2)) + ' cm';
            heightDisplay = parseFloat((heightInInches * 2.54).toFixed(2)) + ' cm';
        } else if (currentUnit === "m") {
            widthDisplay  = parseFloat((widthInInches * 0.0254).toFixed(2)) + ' m';
            heightDisplay = parseFloat((heightInInches * 0.0254).toFixed(2)) + ' m';
        } else {
            widthDisplay  = widthInInches + ' in';
            heightDisplay = heightInInches + ' in';
        }
        propertiesDimension.value = 'W: ' + widthDisplay + ' x H: ' + heightDisplay + ' (' + squareFoot + ' sq ft)';

        Object.keys(productJson).forEach(function(key) {
            if (productJson[key].id === id) {
                var productProperties = productJson[key].price;
                var newPrice = productProperties * squareFoot;
                document.getElementById('properties-set').value = squareFoot;
                document.querySelector('.product_properties span').innerHTML = formatMoneySmart(productProperties);
                document.querySelector('[name="quantity"]').value = squareFoot;
                $('.m2').html(squareFoot);
                $('.product_pricing').html(renderSalePriceHTML(newPrice));
            }
        });
        $('.atc-suffix').show();
    }

    addToCart.disabled = belowMinOrder || overMax;

    panelWidthPercentage();
    if ($('#chartContainer').is(':visible')) {
        setTimeout(function() { canvasRulerInit(); }, 100);
    }
}


    // ##############################################################################################################
    function backgroundRepete(widthInInches, heightInInches){
    if (!dimensionsAreValid) return;
    if (!cropper) return;
    var imgSrc = '';
    var id  = parseInt(document.querySelector('[name="id"]').value);
    Object.keys(productMetaJson).forEach(function(key) {
    if(productMetaJson[key].variant_id == id){
    imgSrc = productMetaJson[key].img;
    }
    });
    var wallpaperImg = new Image();
    wallpaperImg.src = imgSrc
    wallpaperImg.onload = function() {
    var wallpaperImgWidth = wallpaperImg.naturalWidth;
    var wallpaperImgHeight = wallpaperImg.naturalHeight;
    var wallpaperImgHeightRato = wallpaperImgWidth/wallpaperImgHeight;
    if(widthInInches < (heightInInches * wallpaperImgHeightRato)){
    var wallpaperWidthCrop = (widthInInches*wallpaperImgHeight)/heightInInches;
    var minCroppedWidth = wallpaperWidthCrop;
    var minCroppedHeight = wallpaperImgHeight;
    var maxCroppedWidth = wallpaperWidthCrop;
    var maxCroppedHeight = wallpaperImgHeight;
    }else{
    var wallpaperHeightCrop = (heightInInches*wallpaperImgWidth)/widthInInches;
    var minCroppedWidth = wallpaperImgWidth;
    var minCroppedHeight = wallpaperHeightCrop;
    var maxCroppedWidth = wallpaperImgWidth;
    var maxCroppedHeight = wallpaperHeightCrop;
    }
    cropper.setData({width: minCroppedWidth, height: minCroppedHeight});

    if (!cropperUserPositioned) {
        var cropBox = cropper.getCropBoxData();
        var canvas = cropper.getCanvasData();
        var centerX = canvas.width / 2;
        var centerY = canvas.height / 2;
        var cropBoxX = centerX - cropBox.width / 2;
        var cropBoxY = centerY - cropBox.height / 2;
        cropper.setCropBoxData({
            left: cropBoxX,
            top: cropBoxY,
            width: cropBox.width,
            height: cropBox.height
        });
    }
    panelWidthPercentage();
    metaImage.classList.remove('crop-hide');
    }
    setTimeout(function() {
    canvasRulerInit();
    },10);
    }


    // ##############################################################################################################
    var timer = null;
    widthInput.addEventListener('keyup', function() {
    addToCart.disabled = true;
    var inputVal = this.value;
    var inputRGEX = /^[0-9.]*$/;
    var inputResult = inputRGEX.test(inputVal);
    if (!(inputResult)) {
    this.value = this.value.replace(/[^0-9.]/g, '');
    }
    if (isNaN(inputVal)) {
    widthInput.closest(".span_1_of_2").classList.add("error");
    addToCart.disabled = true;
    }else{
    clearTimeout(timer);
    timer = setTimeout(function() {
    changeTheDimensions();
    }, 1800); 
    }
    });


    heightInput.addEventListener('keyup', function() {
    addToCart.disabled = true;
    var inputVal = this.value;
    var inputRGEX = /^[0-9.]*$/;
    var inputResult = inputRGEX.test(inputVal);
    if (!(inputResult)) {
    this.value = this.value.replace(/[^0-9.]/g, '');
    }
    if (isNaN(inputVal)) {
    heightInput.closest(".span_1_of_2").classList.add("error");
    addToCart.disabled = true;
    }else{
    clearTimeout(timer);
    timer = setTimeout(function() {
    changeTheDimensions();
    }, 1800); 
    }
    });
    


    $(customizeAndBuy).on('click', function() {
      addToCart.disabled = true;
        let id = parseInt($('[name="id"]').val());

        $('.custom-variations fieldset').each(function() {
          
            let $fieldset = $(this);
            let customOption = $fieldset.attr("data");
            let matchingProduct = productJson.find(p => p.id === id);
            
            if (matchingProduct) {
                let value = matchingProduct[customOption];

                if ($fieldset.find('select').length) {
                    $fieldset.find('select').val(value).trigger('change');
                } else if ($fieldset.find('input').length) {
                    $fieldset.find('input').each(function() {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).trigger('change');
                            $fieldset.find('.form__label__value').text(value);
                        }
                    });
                }
            }
        });
      openPopup();
      switch_input.checked = false;

      if (!areDimensionsFilled()) {
          showEmptyDimensionsAlert();
      } else {
          hideEmptyDimensionsAlert();
      }
      updateAddToCartButtonState();

      setTimeout(function() {
      var widthInInches = parseFloat(widthInput.value);
      var heightInInches = parseFloat(heightInput.value);
      changeTheDimensions()
     }, 2000);
    });

function sampleaddToCartItem(sampleProductsId, qty, btn, price) {
 
    var items = [{ id: sampleProductsId, quantity: qty }];
    if (materialBookAdded && materialBookVariantId) {
        items.push({ id: materialBookVariantId, quantity: 1 });
    }
    var data = { items: items };
 
    fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(res => {
            if (res.status == 422) {
                btn.disabled = false;
                btn.innerHTML = `Add To Cart &nbsp;|&nbsp; $${price}`;
            } else {
                if (materialBookAdded && res.items && res.items.length > 1) {
                    materialBookLineKey = res.items[1].key;
                }
 
                btn.disabled = false;
                btn.innerHTML = `Sample Added`;
                updatesampleCartCount();
 
                var sampleNameForToast = document.querySelector('.drawer--title')
                    ? document.querySelector('.drawer--title').textContent.trim()
                    : 'Sample';
                showSampleAddedToast(sampleNameForToast);
 
                // drawerOverlay.classList.remove('active');
                // drawer.classList.remove('active');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            btn.disabled = false;
            btn.innerHTML = `Add To Cart &nbsp;|&nbsp; $${price}`;
        });
}

function updatesampleCartCount() {
    fetch('/cart.js?_=' + Date.now())
    .then(response => response.json())
    .then(cart => {

        const count = cart.item_count;

        document.querySelectorAll('.thb-item-count').forEach(el => {
            el.textContent = count;
            el.style.display = count > 0 ? '' : 'none';
        });

        document.dispatchEvent(
            new CustomEvent('cart:updated', {
                detail: {
                    cart: cart
                }
            })
        );

		document.documentElement.dispatchEvent(
			new CustomEvent('cart:refresh', {
				bubbles: true
			})
		);


    })
    .catch(err => {
        console.error('❌ Cart count update error:', err);
    });
}


const orderSampleBtn = document.querySelector('.order-sample-btn');
const drawerOverlay = document.querySelector('.orderSample-drawer-overlay');
const drawer = document.querySelector('.orderSample-drawer');
const samplecloseBtn = document.querySelector('.orderSample-drawer .sample-cross-btn');
const shoppingcloseBtn = document.querySelector('.orderSample-drawer .btn-continue-shop');  
const drawerAddToCartBtn = document.querySelector('.orderSample-drawer .sampleOrder_addto_cart'); // your drawer's add to cart button

order_sample_btn.addEventListener('click', function() {
    drawerOverlay.classList.add('active');
    drawer.classList.add('active');
    resetMaterialBookState();
    clearSampleSelection();
    updateDrawerAddToCartButtonText();
});

samplecloseBtn.addEventListener('click', function() {
    drawerOverlay.classList.remove('active');
    drawer.classList.remove('active');
});

shoppingcloseBtn.addEventListener('click', function() {
    drawerOverlay.classList.remove('active');
    drawer.classList.remove('active');
});

drawerOverlay.addEventListener('click', function() {
    drawerOverlay.classList.remove('active');
    drawer.classList.remove('active');
});

document.addEventListener('click', function(e) {
    var swatchBtn = e.target.closest('.orderSample-drawer [data-sample-swatch]');
    if (!swatchBtn) return;
    if (swatchBtn.disabled) return;

    var isSelected = swatchBtn.getAttribute('aria-pressed') === 'true';
    swatchBtn.setAttribute('aria-pressed', isSelected ? 'false' : 'true');
    swatchBtn.classList.toggle('is-selected', !isSelected);
    updateDrawerAddToCartButtonText();
});

// ---- ADD TO CART inside drawer (bundled, multi-item) ----

drawerAddToCartBtn.addEventListener('click', function() {
    var wrap = getSampleMultiselectWrap();
    var selected = getSelectedSampleSwatches(wrap);

    var items = [];
    selected.forEach(function(btn) {
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) {
            items.push({ id: parseInt(variantId, 10), quantity: 1 });
        }
    });
    if (!items.length) return;

    var bookIncluded = false;
    if (materialBookAdded && materialBookVariantId) {
        items.push({ id: materialBookVariantId, quantity: 1 });
        bookIncluded = true;
    }

    drawerAddToCartBtn.disabled = true;
    var originalText = drawerAddToCartBtn.innerHTML;
    drawerAddToCartBtn.innerHTML = '<span class="sample-cart-loader"></span> Adding...';

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
    })
        .then(function(response) { return response.json(); })
        .then(function(res) {
            if (res.status == 422) {
                drawerAddToCartBtn.disabled = false;
                drawerAddToCartBtn.innerHTML = originalText;
                return;
            }

            if (bookIncluded && res.items && res.items.length) {
                materialBookLineKey = res.items[res.items.length - 1].key;
            }

            clearSampleSelection();
            updatesampleCartCount();

            var label = items.length === 1 ? '1 sample' : items.length + ' samples';
            showSampleAddedToast(label);

            updateDrawerAddToCartButtonText();
        })
        .catch(function(err) {
            console.error('Error adding samples to cart:', err);
            drawerAddToCartBtn.disabled = false;
            drawerAddToCartBtn.innerHTML = originalText;
        });
});


    addToCart.addEventListener('click', function() {

    var unitForCart = $(".unit-selector:not(.read-select)").first().val();
    var widthInInchesForCart  = parseFloat(widthInput.value)  || 0;
    var heightInInchesForCart = parseFloat(heightInput.value) || 0;
    var squareFootForCart = convertToSquareMeters(widthInInchesForCart, heightInInchesForCart);
    var propertiesDimension2 = $('#properties-dimension2');
    let widthDisplay, heightDisplay;
    if (unitForCart === "ft/in" || unitForCart === "inch") {
        var wInVal = parseFloat(widthInInchesForCart.toFixed(2));
        var hInVal = parseFloat(heightInInchesForCart.toFixed(2));
        widthDisplay  = wInVal + ' in';
        heightDisplay = hInVal + ' in';
    } else {
        var wCmVal = parseFloat((widthInInchesForCart * 2.54).toFixed(2));
        var hCmVal = parseFloat((heightInInchesForCart * 2.54).toFixed(2));
        widthDisplay  = wCmVal + ' cm';
        heightDisplay = hCmVal + ' cm';
    }

    propertiesDimension2.val('W: ' + widthDisplay + ' x H: ' + heightDisplay + ' (' + squareFootForCart + ' sq ft)');


    $('.popup').addClass('open');
	  $('.loader-wall').css('display', 'flex');
    var brdr_cntr = document.querySelector('.brdr_cntr');
    if (brdr_cntr) {
      brdr_cntr.style.display = 'none';
    }
     switch_input.checked = false;

    var __t0 = performance.now();

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        var __tSettle = performance.now();

        var croppedCanvas = cropper.getCroppedCanvas();

        var __tRender = performance.now();

        croppedCanvas.toBlob(function(blob) {
          if (!blob) {
            loaderWall.style.display = 'none';
            return;
          }

          var __tEncode = performance.now();

          client.upload(blob, {}, token)
          .then(res => {
            var __tUpload = performance.now();

            selectedDesign.value = res.url;
            document.querySelector('.single_add_to_cart_button').click();
            loaderWall.style.display = 'block';
            $('body').removeClass('open-cc');
            $('.popup').removeClass('open');
            loaderWall.style.display = 'none';
            openCartDrawer();
          })
          .catch(err => {
            loaderWall.style.display = 'none';
          });
        }, 'image/jpeg', 0.85);
      });
    });
  });


function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
}

    var quickView = localStorage.getItem("quickView");
    if(quickView == 'true'){
    openPopup();
    changeTheDimensions();
    localStorage.setItem("quickView", "false");
    }




// new jas for rolls

//   var price_roll  = document.querySelector('.product-price-js');
//   var productsRollsJson = JSON.parse(document.getElementById('products_rolls-json').textContent);
    function addToCartItem1(sampleProductsId,qty) {
       var data = {
        id: sampleProductsId,
        quantity:qty
      }
      buySampleProducts.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(res => {
        if(res.status == 422){
          return;
        } 
        updatesampleCartCount();
        openCartDrawer();

        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
          cartDrawerEl.open();
        } else {
          document.body.classList.add('open-cc');
        }
      })
      .catch(error => {
        console.error('Error:', error);
      })
      .finally(()=>{
        buySampleProducts.classList.remove('loading');
      })
      }

    function getSKUById(id) {
        const product = productJson.find(item => item.id === id);
        return product ? product.sku : "Product not found";
    }

    buySampleProducts.addEventListener('click', function(event) {
    event.preventDefault();
    var properties = {};
    var productTitle = document.querySelector('.product-title').innerText;
    var id  = parseInt(document.querySelector('[name="id"]').value);
    document.querySelectorAll(".MS_option-name").forEach((el, idx) => {
    var option = el.getAttribute("data");
    var optionName = el.querySelector('.option-name').innerText;
    // properties['Title'] = productTitle;
    // if(optionName != 'Material'){
    //   Object.keys(productJson).forEach(function(key) {
    //    if(productJson[key].id == id){
    //       properties[optionName] = productJson[key][option];
    //   }
    //   });
    //}
    // Mappings
    // const sizeMapping = {
    //   '25" × 50" (63.5 cm × 1.27 m) Roll': '25x50in',
    //   '25" × 75" (63.5 cm × 1.91 m) Roll': '25x75in',
    //   '25" × 100" (63.5 cm × 2.54 m) Roll': '25x100in',
    //   '25" × 125" (63.5 cm × 3.18 m) Roll': '25x125in',
    //   '25" × 150" (63.5 cm × 3.81 m) Roll': '25x150in',
    //   '25" × 200" (63.5 cm × 5.08 m) Roll': '25x200in',
    //   '25" × 393.7" (63.5 cm × 10 m) Roll': '25x393.7in',
    //   'A3 Sample – 11.7" × 16.5" (29.7 cm × 42 cm)': 'SampleA3'
    // };

    const sizeMapping = {
        // Optional: only define specific custom mappings
        // If you don’t need any, leave this empty
      'A3 Sample – 11.7" × 16.5" (29.7 cm × 42 cm)': 'SampleA3'
      };

    function extractInchDimensions(label) {
      if (typeof label !== 'string') return 'unknownSize';
    
      try {
        const inchRegex = /([\d.]+)"\s*[×x]\s*([\d.]+)"/;
        const match = label.match(inchRegex);
        if (match && match[1] && match[2]) {
          const w = match[1].replace(/\.0$/, '');
          const h = match[2].replace(/\.0$/, '');
          return `${w}x${h}in`;
        }
      } catch (e) {
        console.warn('extractInchDimensions error:', e);
      }
    
      return label.replace(/[^a-zA-Z0-9]/g, '') || 'unknownSize';
    }


    const materialMapping = {
      'ECO - Paste the wall matte': 'Eco',
      'Peel & Stick': 'Peel & Stick',
      'Peel & Stick Vinyl - limited stock': 'PSVinyl',
      'Pre-pasted - limited stock': 'PrePasted',
      'Pro-Vinyl Sand | Non-woven': 'Sand',
      'Pro-Vinyl Concrete | Non-woven': 'Concrete',
      'Pro-Vinyl Line | Non-woven': 'Line',
      'Pro-Vinyl Como | Non-woven': 'Como',
      'Pro-Vinyl Leaves | Non-woven': 'Leaves',
      'Pro-Vinyl Canvas | Non-woven': 'Canvas',
      'Pro-Vinyl Fabric | Non-woven': 'Fabric',
      'Pro-Vinyl Rope | Non-woven': 'Rope'
    };
    
    // Get SKU
    const sku = getSKUById(id);
    
    });

   var Material = document.querySelector('[name="options[Material]"]');
    if(Material){
    var sampleMaterial  = Material.value;
    }else{
    var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
    }
      
    var rollSize  = document.querySelector('.variant-selector-js').value;
    var qty  = parseInt(document.querySelector('#Quantity-products_rolls').value);

    var title = sampleMaterial+' / '+rollSize;
    var sampleProductsId = id;

      addToCartItem1(sampleProductsId,qty);
    });




    function handleChange() {
    const selectedValue = roll_select.value; // your custom select value
    var Material = document.querySelector('[name="options[Material]"]');
    const updateVariantId = document.querySelector('[name="id"]');

    if(Material){
    var sampleMaterial  = Material.value;
    }else{
    var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
    }
    if(selectedValue != ''){
      price_main.style.display = 'none';
      price_roll.style.display = 'flex';

      var title = sampleMaterial+' / '+selectedValue;
      var storedPriceType = '<span class="pricetype" style="font-size: 0.82rem; opacity: 0.75; margin-left: 4px;"> per panel</span>';
        Object.keys(productJson).forEach(function(key) {
          if(productJson[key].title == title){
            var variantID = productJson[key].id;
            var roll_available = productJson[key].available;
            var variantPrice = productJson[key].price;
             var imgSrc = productMetaJson[key].img;
            var sku = getSKUById(variantID);
            const thumbImage = document.querySelector('.thumb-media img');
            if (thumbImage) {
              thumbImage.src = imgSrc;
            }

            // Update SKU text
            const skuElement = document.querySelector('.thumb-prod-sku');
            if (skuElement) {
              skuElement.textContent = 'SKU: ' + sku;
            }
            if(roll_available === true){
                price_roll.innerHTML = renderSalePriceHTML(variantPrice, ' ' + storedPriceType);
                buySampleProducts.disabled = false;
                setBuySampleButtonText("Add To Cart");
              }else{
                price_roll.innerHTML = renderSalePriceHTML(variantPrice, ' ' + storedPriceType + '<span class="badges"><span class="badge out-of-stock">Sold Out</span></span>');
                buySampleProducts.disabled = true;
                setBuySampleButtonText("Sold Out");
              }
              const shopifySelect = document.querySelector('select[name="options[Type]"]');
              if (shopifySelect) {
                  // Find matching option
                  const shopifyOption = Array.from(shopifySelect.options).find(
                  option => option.value === selectedValue
                  );

                if (shopifyOption) {
                  shopifySelect.value = shopifyOption.value;
                  updateVariantId.value = variantID;

                  // Trigger Shopify's change event so the product form updates (price, availability, etc.)
                  shopifySelect.dispatchEvent(new Event('change', { bubbles: true }));
                  } 
              } 
          }
      });
    }else{
      buySampleProducts.disabled = true;
      price_main.style.display = 'block';
      price_roll.style.display = 'none';
    }
  }


     function handleChangeMaterial() {
    var Material = document.querySelector('[name="options[Material]"]');
    const updateVariantId = document.querySelector('[name="id"]');
      if(Material){
      var sampleMaterial  = Material.value;
      }else{
      var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
      }
      var rollSize  = document.querySelector('.variant-selector-js').value;
      const shopifySelect = document.querySelector('select[name="options[Type]"]');
      var orderTypeval = document.querySelector('[name="orderType"]:checked').value;
      var storedPriceType = '<span class="pricetype"> per panel</span>';

      if(orderTypeval == 'roll'){
        if(rollSize != ''){
          const selectedValue = shopifySelect.value;
          var title = sampleMaterial+' / '+selectedValue;
           Object.keys(productJson).forEach(function(key) {
            if(productJson[key].title == title){
              var variantID = productJson[key].id;
              var roll_available = productJson[key].available;
              var variantPrice = productJson[key].price;
              if(roll_available === true){
                  price_roll.innerHTML = Shopify.formatMoney(variantPrice, moneyFormat) +' '+ storedPriceType;
                  buySampleProducts.disabled = false;
                  setBuySampleButtonText("Add To Cart");
                }else{
                  price_roll.innerHTML = Shopify.formatMoney(variantPrice, moneyFormat) +' '+ storedPriceType + '<span class="badges"><span class="badge out-of-stock">Sold Out</span></span>';
                  buySampleProducts.disabled = true;
                  setBuySampleButtonText("Sold Out");
                }
              }
            });
        }else{
          buySampleProducts.disabled = true;
          price_main.style.display = 'block';
          price_roll.style.display = 'none';
        }
      }
    }

   var materialElements = document.querySelectorAll('[name="options[Material]"]');
    if(materialElements.length === 0){
        var materialElements = document.querySelectorAll('[name="Material"]');
    }
 
    materialElements.forEach(element => {
    element.addEventListener('change', handleChangeMaterial);
    });

  roll_select.addEventListener('change', function() {
      handleChange();
    });
  roll_select.dispatchEvent(new Event('change'));
  
  function orderTypeChange(eventOrElement){
       const value = eventOrElement?.target 
      ? eventOrElement.target.value   // when called from event
      : eventOrElement?.value;        // when called with element

    var main_roll = document.querySelector('.products_rolls-main');
    var button_container = document.querySelector('.button-container');
    var typeSelects = document.querySelectorAll('[name="options[Type]"]');
    const storedPriceType = localStorage.getItem('priceType') || ' per panel';
    
    if(value == 'custom'){
    const selectedValue = "Custom"; // your dynamic value
    if (typeSelects.length > 0) {
      typeSelects.forEach(select => {
          const match = Array.from(select.options).find(
          option => option.value === selectedValue
          );
          if (match) {
          select.value = selectedValue;
  
          // trigger change so Shopify updates variant
          select.dispatchEvent(new Event("change", { bubbles: true }));

          
          }
      });
    }
    main_roll.style.display = 'none';
    price_roll.style.display = 'none';
    button_container.style.display = 'block';
    price_main.style.display = 'block';
    
    }else {
      button_container.style.display = 'none';
      main_roll.style.display = 'block';
    
    var rollSize  = document.querySelector('.variant-selector-js').value;
    
    if(rollSize != ''){
      price_main.style.display = 'none';
      price_roll.style.display = 'flex';
      }else{
      price_main.style.display = 'block';
      price_roll.style.display = 'none';
    }

      if (typeSelects.length > 0) {
        typeSelects.forEach(select => {
            const match = Array.from(select.options).find(
            option => option.value === rollSize
            );
            if (match) {
            select.value = rollSize;
    
            // trigger change so Shopify updates variant
            select.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
      }

    if (eventOrElement?.target) {
    var Material = document.querySelector('[name="options[Material]"]');
    var sampleMaterial = Material ? Material.value : document.querySelector('[name="Material"]:checked').value;
    var title = sampleMaterial + ' / ' + rollSize;

    Object.keys(productJson).forEach(function(key) {
      if(productJson[key].title == title){
        var variantID = productJson[key].id;
        var roll_available = productJson[key].available;
        var variantPrice = productJson[key].price;
        if(roll_available === true){
            price_roll.innerHTML = Shopify.formatMoney(variantPrice, moneyFormat) +' '+ storedPriceType;
            buySampleProducts.disabled = false;
            setBuySampleButtonText("Add To Cart");
          }else{
            price_roll.innerHTML = Shopify.formatMoney(variantPrice, moneyFormat) +' '+ storedPriceType + '<span class="badges"><span class="badge out-of-stock">Sold Out</span></span>';
            buySampleProducts.disabled = true;
            setBuySampleButtonText("Sold Out");
          }
        }
      });
      }
    }
  }

  const orderTypeElements = document.querySelectorAll('[name="orderType"]');
    orderTypeElements.forEach(element => {
    element.addEventListener('change', orderTypeChange);
    });

     document.addEventListener("DOMContentLoaded", function() {
      const priceTypeEl = document.querySelector('.pricetype');
      if (priceTypeEl) {
        const priceTypeValue = priceTypeEl.outerHTML;
        localStorage.setItem('priceType', priceTypeValue);
      }
    // wait a bit to ensure Shopify finished setting the selected option
    setTimeout(() => {
      const selectedOrderType = document.querySelector('[name="orderType"]:checked');
      if (selectedOrderType) {
        orderTypeChange(selectedOrderType);
      }
    }, 2000); // run 2s after page load

    const selectedUnit = $(".dimension-header .unit-selector").val();
    updateDimensionFields(selectedUnit);
	  initDimensionFields();
    updateAddToCartButtonState();
    // $(".dimension-header .unit-selector").trigger("change");
  });

  //  new code march 2025

	$(".unit-selector").on("change", function () {

    // Ignore read-only unit dropdowns
    if ($(this).hasClass("read-select")) return;

    const selectedUnit = $(this).val();

    // ✅ Sync ALL non-read-select unit selectors on the page
    $(".unit-selector:not(.read-select)").val(selectedUnit);

    // ✅ Update field visibility/labels for both wrappers
    updateDimensionFields(selectedUnit);

    var rawW = $("#width_in_inches").val();
    var rawH = $("#height_in_inches").val();
    var noDimensionsYet = (rawW === "" || rawW === undefined) && (rawH === "" || rawH === undefined);

    if (noDimensionsYet) {
        $("#width_in_inches_input").val("");
        $("#width_in").val("");
        $("#height_in_inches_input").val("");
        $("#height_in").val("");
        $("#preview_width_ft").val("");
        $("#preview_width_in").val("");
        $("#preview_height_ft").val("");
        $("#preview_height_in").val("");
        return;
    }

    // Source of truth — always in inches
    const heightInInches = parseFloat($("#height_in_inches").val()) || 0;
    const widthInInches  = parseFloat($("#width_in_inches").val())  || 0;

    if (selectedUnit === "ft/in") {

    // ✅ Use normalizeFtIn to avoid floating point errors
    const normW = normalizeFtIn(0, widthInInches);
    const normH = normalizeFtIn(0, heightInInches);

    // Popup fields
    $("#width_in_inches_input").val(normW.ft);
    $("#width_in").val(normW.inches);
    $("#height_in_inches_input").val(normH.ft);
    $("#height_in").val(normH.inches);

    // Page fields
    $("#preview_width_ft").val(normW.ft);
    $("#preview_width_in").val(normW.inches);
    $("#preview_height_ft").val(normH.ft);
    $("#preview_height_in").val(normH.inches);

    // changeTheDimensions();
      canvasRulerInit();
    return;
	} else {

        let widthConverted, heightConverted;

        switch (selectedUnit) {
            case "cm":
                widthConverted  = parseFloat((widthInInches  * 2.54).toFixed(2));
                heightConverted = parseFloat((heightInInches * 2.54).toFixed(2));
                break;
            case "m":
                widthConverted  = parseFloat((widthInInches  * 0.0254).toFixed(2));
                heightConverted = parseFloat((heightInInches * 0.0254).toFixed(2));
                break;
            case "inch":
            default:
                widthConverted  = parseFloat(widthInInches.toFixed(2));
                heightConverted = parseFloat(heightInInches.toFixed(2));
                break;
        }

        // --- POPUP fields (single field, clear second) ---
        $("#width_in_inches_input").val(widthConverted);
        $("#width_in").val("");
        $("#height_in_inches_input").val(heightConverted);
        $("#height_in").val("");

        // --- PAGE fields (single field, clear second) ---
        $("#preview_width_ft").val(widthConverted);
        $("#preview_width_in").val("");
        $("#preview_height_ft").val(heightConverted);
        $("#preview_height_in").val("");
    }
    // changeTheDimensions();
    canvasRulerInit();
});

function updateDimensionFields(selectedUnit) {

    if (selectedUnit === "ft/in") {

        $(".dimension-field-container").each(function () {
            // Show both fields
            $(this).find(".dimension-field").removeClass("hidden");
            // Label them
            const selects = $(this).find(".read-select");
            selects.eq(0).val("ft");
            selects.eq(1).val("inch");
        });

    } else {

        $(".dimension-field-container").each(function () {
            const fields = $(this).find(".dimension-field");
            // Show first, hide second
            $(fields[0]).removeClass("hidden").find(".read-select").val(selectedUnit);
            $(fields[1]).addClass("hidden");
        });
    }
}

// Page section input → update hidden inch fields + sync popup
// ✅ Add this helper at the top of your script
function normalizeFtIn(ft, inches) {
    // Accept either (ft, inches) or (0, totalInches)
    const totalInches = parseFloat(((ft * 12) + inches).toFixed(2));
    return {
        ft:     Math.floor(totalInches / 12),
        inches: parseFloat((totalInches % 12).toFixed(2)),
        total:  totalInches
    };
}


// ✅ Unified function to update hidden fields + sync both UIs
function syncFromPopupInputs() {
    const unit = $(".unit-selector:not(.read-select)").first().val();
    if (unit === "ft/in") {
        const wFt  = parseFloat($("#width_in_inches_input").val())  || 0;
        const wIns = parseFloat($("#width_in").val())               || 0;
        const hFt  = parseFloat($("#height_in_inches_input").val()) || 0;
        const hIns = parseFloat($("#height_in").val())              || 0;

        // ✅ wFt already holds feet, wIns holds inches — normalize if inches >= 12
        const normW = normalizeFtIn(wFt, wIns);
        const normH = normalizeFtIn(hFt, hIns);

        // Update hidden source of truth
        $("#width_in_inches").val(normW.total);
        $("#height_in_inches").val(normH.total);

        // Write normalized values back to popup inputs
        $("#width_in_inches_input").val(normW.ft);
        $("#width_in").val(normW.inches);
        $("#height_in_inches_input").val(normH.ft);
        $("#height_in").val(normH.inches);

        // Sync page inputs
        $("#preview_width_ft").val(normW.ft);
        $("#preview_width_in").val(normW.inches);
        $("#preview_height_ft").val(normH.ft);
        $("#preview_height_in").val(normH.inches);

    } else {
        const wVal = parseFloat($("#width_in_inches_input").val())  || 0;
        const hVal = parseFloat($("#height_in_inches_input").val()) || 0;

        let wInches, hInches;
        switch (unit) {
            case "cm": wInches = wVal / 2.54;   hInches = hVal / 2.54;   break;
            case "m":  wInches = wVal / 0.0254; hInches = hVal / 0.0254; break;
            default:   wInches = wVal;           hInches = hVal;          break;
        }

        $("#width_in_inches").val(wInches.toFixed(2));
        $("#height_in_inches").val(hInches.toFixed(2));

        $("#preview_width_ft").val(wVal);
        $("#preview_width_in").val("");
        $("#preview_height_ft").val(hVal);
        $("#preview_height_in").val("");
    }
}

// ✅ Unified function to sync from page inputs to popup + hidden fields
function syncFromPageInputs() {
    const unit = $(".unit-selector:not(.read-select)").first().val();
    if (unit === "ft/in") {
        const wFt  = parseFloat($("#preview_width_ft").val())  || 0;
        const wIns = parseFloat($("#preview_width_in").val())  || 0;
        const hFt  = parseFloat($("#preview_height_ft").val()) || 0;
        const hIns = parseFloat($("#preview_height_in").val()) || 0;

        const normW = normalizeFtIn(wFt, wIns);
        const normH = normalizeFtIn(hFt, hIns);

        $("#width_in_inches").val(normW.total);
        $("#height_in_inches").val(normH.total);

        $("#preview_width_ft").val(normW.ft);
        $("#preview_width_in").val(normW.inches);
        $("#preview_height_ft").val(normH.ft);
        $("#preview_height_in").val(normH.inches);

        $("#width_in_inches_input").val(normW.ft);
        $("#width_in").val(normW.inches);
        $("#height_in_inches_input").val(normH.ft);
        $("#height_in").val(normH.inches);

    } else {
        const wVal = parseFloat($("#preview_width_ft").val())  || 0;
        const hVal = parseFloat($("#preview_height_ft").val()) || 0;

        let wInches, hInches;
        switch (unit) {
            case "cm": wInches = wVal / 2.54;   hInches = hVal / 2.54;   break;
            case "m":  wInches = wVal / 0.0254; hInches = hVal / 0.0254; break;
            default:   wInches = wVal;           hInches = hVal;          break;
        }

        $("#width_in_inches").val(wInches.toFixed(2));
        $("#height_in_inches").val(hInches.toFixed(2));

        $("#width_in_inches_input").val(wVal);
        $("#width_in").val("");
        $("#height_in_inches_input").val(hVal);
        $("#height_in").val("");
    }
}

function isFirstVisitNoDimensions() {
    var w = $("#width_in_inches").val();
    var h = $("#height_in_inches").val();
    var wNum = parseFloat(w);
    var hNum = parseFloat(h);
    return (w === "" || isNaN(wNum) || wNum === 0) &&
           (h === "" || isNaN(hNum) || hNum === 0);
}


// ✅ Add this — initialize ft/in display fields correctly on page load
function initDimensionFields() {
    var saved = getSavedDimensions();
    const unit = $(".unit-selector:not(.read-select)").first().val();

    if (!saved) {
        // 🆕 TRUE first-time visitor (or expired) — blank EVERYTHING
        $("#width_in_inches").val("");
        $("#height_in_inches").val("");

        $("#width_in_inches_input").val("");
        $("#width_in").val("");
        $("#height_in_inches_input").val("");
        $("#height_in").val("");

        $("#preview_width_ft").val("");
        $("#preview_width_in").val("");
        $("#preview_height_ft").val("");
        $("#preview_height_in").val("");
        return;
    }

    // ✅ Saved & not expired — restore source of truth + visible fields
    $("#width_in_inches").val(saved.width);
    $("#height_in_inches").val(saved.height);

    if (unit === "ft/in") {
        var normW = normalizeFtIn(0, saved.width);
        var normH = normalizeFtIn(0, saved.height);

        $("#width_in_inches_input").val(normW.ft);
        $("#width_in").val(normW.inches);
        $("#height_in_inches_input").val(normH.ft);
        $("#height_in").val(normH.inches);

        $("#preview_width_ft").val(normW.ft);
        $("#preview_width_in").val(normW.inches);
        $("#preview_height_ft").val(normH.ft);
        $("#preview_height_in").val(normH.inches);
    } else {
        let wConverted, hConverted;
        switch (unit) {
            case "cm":
                wConverted = parseFloat((saved.width  * 2.54).toFixed(2));
                hConverted = parseFloat((saved.height * 2.54).toFixed(2));
                break;
            case "m":
                wConverted = parseFloat((saved.width  * 0.0254).toFixed(2));
                hConverted = parseFloat((saved.height * 0.0254).toFixed(2));
                break;
            default:
                wConverted = parseFloat(saved.width.toFixed(2));
                hConverted = parseFloat(saved.height.toFixed(2));
        }

        $("#width_in_inches_input").val(wConverted);
        $("#width_in").val("");
        $("#height_in_inches_input").val(hConverted);
        $("#height_in").val("");

        $("#preview_width_ft").val(wConverted);
        $("#preview_width_in").val("");
        $("#preview_height_ft").val(hConverted);
        $("#preview_height_in").val("");
    }
}

function safeNumber(val) {
    if (val === "" || val === null || typeof val === "undefined") {
        return null;
    }

    const num = parseFloat(val);

    return isNaN(num) ? null : num;
}

// ================= WIDTH INCHES FIELD (2nd field in ft/in) =================
$("#width_in").off("keyup input change");
$("#width_in").on("keyup input change", function () {

    const unit = $(".unit-selector:not(.read-select)").first().val();
    if (unit !== "ft/in") return;

    clearTimeout(window.widthInTimer);
    window.widthInTimer = setTimeout(() => {

        let ft  = safeNumber($("#width_in_inches_input").val()) || 0;
        let ins = safeNumber($("#width_in").val()) || 0;

        // normalize if inches >= 12
        if (ins >= 12) {
            const norm = normalizeFtIn(ft, ins);
            ft  = norm.ft;
            ins = norm.inches;
            $("#width_in_inches_input").val(ft);
            $("#width_in").val(ins);
        }

        const total = parseFloat(((ft * 12) + ins).toFixed(2));

        // ✅ Update hidden inch field
        $("#width_in_inches").val(total);

        // ✅ Sync page preview fields
        $("#preview_width_ft").val(ft);
        $("#preview_width_in").val(ins);

        // ✅ Update dimension text label immediately
        const hFt = Math.floor((parseFloat($("#height_in_inches").val()) || 0) / 12);
        const hIn = parseFloat(((parseFloat($("#height_in_inches").val()) || 0) % 12).toFixed(2));
        const widthLabel  = ins > 0 ? `${ft} ft ${ins} in` : `${ft} ft`;
        const heightLabel = hIn > 0 ? `${hFt} ft ${hIn} in` : `${hFt} ft`;
        $('.walltool-canvas-width span').text(widthLabel);
        $('.walltool-canvas-height span').text(heightLabel);
        $('.sixe__info').text(`${widthLabel} x ${heightLabel}`);

        changeTheDimensions();

    }, 300);
});


// ================= HEIGHT INCHES FIELD (2nd field in ft/in) =================
$("#height_in").off("keyup input change");
$("#height_in").on("keyup input change", function () {

    const unit = $(".unit-selector:not(.read-select)").first().val();
    if (unit !== "ft/in") return;

    clearTimeout(window.heightInTimer);
    window.heightInTimer = setTimeout(() => {

        let ft  = safeNumber($("#height_in_inches_input").val()) || 0;
        let ins = safeNumber($("#height_in").val()) || 0;

        // normalize if inches >= 12
        if (ins >= 12) {
            const norm = normalizeFtIn(ft, ins);
            ft  = norm.ft;
            ins = norm.inches;
            $("#height_in_inches_input").val(ft);
            $("#height_in").val(ins);
        }

        const total = parseFloat(((ft * 12) + ins).toFixed(2));

        // ✅ Update hidden inch field
        $("#height_in_inches").val(total);

        // ✅ Sync page preview fields
        $("#preview_height_ft").val(ft);
        $("#preview_height_in").val(ins);

        // ✅ Update dimension text label immediately
        const wFt = Math.floor((parseFloat($("#width_in_inches").val()) || 0) / 12);
        const wIn = parseFloat(((parseFloat($("#width_in_inches").val()) || 0) % 12).toFixed(2));
        const widthLabel  = wIn > 0 ? `${wFt} ft ${wIn} in` : `${wFt} ft`;
        const heightLabel = ins > 0 ? `${ft} ft ${ins} in` : `${ft} ft`;
        $('.walltool-canvas-width span').text(widthLabel);
        $('.walltool-canvas-height span').text(heightLabel);
        $('.sixe__info').text(`${widthLabel} x ${heightLabel}`);

        changeTheDimensions();

    }, 300);
});


// ================= WIDTH FT FIELD (1st field in ft/in) =================
$("#width_in_inches_input").off("keyup input change");
$("#width_in_inches_input").on("keyup input change", function () {

    const unit = $(".unit-selector:not(.read-select)").first().val();

    clearTimeout(window.widthFtTimer);
    window.widthFtTimer = setTimeout(() => {

        if (unit === "ft/in") {
            let ft  = safeNumber($("#width_in_inches_input").val()) || 0;
            let ins = safeNumber($("#width_in").val()) || 0;
            const total = parseFloat(((ft * 12) + ins).toFixed(2));

            $("#width_in_inches").val(total);
            $("#preview_width_ft").val(ft);
            $("#preview_width_in").val(ins);

            // ✅ Update label
            const hTotal = parseFloat($("#height_in_inches").val()) || 0;
            const hFt = Math.floor(hTotal / 12);
            const hIn = parseFloat((hTotal % 12).toFixed(2));
            const widthLabel  = ins > 0 ? `${ft} ft ${ins} in` : `${ft} ft`;
            const heightLabel = hIn > 0 ? `${hFt} ft ${hIn} in` : `${hFt} ft`;
            $('.walltool-canvas-width span').text(widthLabel);
            $('.walltool-canvas-height span').text(heightLabel);
            $('.sixe__info').text(`${widthLabel} x ${heightLabel}`);

        } else {
            syncFromPopupInputs();
        }

        changeTheDimensions();
    }, 300);
});


// ================= HEIGHT FT FIELD (1st field in ft/in) =================
$("#height_in_inches_input").off("keyup input change");
$("#height_in_inches_input").on("keyup input change", function () {

    const unit = $(".unit-selector:not(.read-select)").first().val();

    clearTimeout(window.heightFtTimer);
    window.heightFtTimer = setTimeout(() => {

        if (unit === "ft/in") {
            let ft  = safeNumber($("#height_in_inches_input").val()) || 0;
            let ins = safeNumber($("#height_in").val()) || 0;
            const total = parseFloat(((ft * 12) + ins).toFixed(2));

            $("#height_in_inches").val(total);
            $("#preview_height_ft").val(ft);
            $("#preview_height_in").val(ins);

            // ✅ Update label
            const wTotal = parseFloat($("#width_in_inches").val()) || 0;
            const wFt = Math.floor(wTotal / 12);
            const wIn = parseFloat((wTotal % 12).toFixed(2));
            const widthLabel  = wIn > 0 ? `${wFt} ft ${wIn} in` : `${wFt} ft`;
            const heightLabel = ins > 0 ? `${ft} ft ${ins} in` : `${ft} ft`;
            $('.walltool-canvas-width span').text(widthLabel);
            $('.walltool-canvas-height span').text(heightLabel);
            $('.sixe__info').text(`${widthLabel} x ${heightLabel}`);

        } else {
            syncFromPopupInputs();
        }

        changeTheDimensions();
    }, 300);
});

// REPLACE WITH THIS (safe version - only change is syncFromPageInputs INSIDE timeout):
let timerPage = null;
$("#preview_width_ft, #preview_width_in, #preview_height_ft, #preview_height_in").on("keyup input", function() {
    clearTimeout(timerPage);
    timerPage = setTimeout(function() {
        syncFromPageInputs();   // sync first, then validate
        changeTheDimensions();  // then validate
    }, 800);
});

    var quickView = localStorage.getItem("quickView");
    if (quickView == 'true') {
    	var id = parseInt(document.querySelector('[name="id"]').value);
    	document.querySelectorAll(".MS_option-name").forEach((el, idx) => {
    		var option = el.getAttribute("data");
    		Object.keys(productJson).forEach(function(key) {
    			if (productJson[key].id == id) {
    				el.querySelector('.option-value').innerHTML = productJson[key][option];
    			}
    		});
    	});
    	openPopup();
    	changeTheDimensions();
    	localStorage.setItem("quickView", "false");
    }


function calculatePanels() {
    var totalWidth = $('#width_in_inches').val();
    const minPanelWidth = parseFloat($('#panelWidth').attr('min')) || 19;
    const maxPanelWidth = parseFloat($('#panelWidth').attr('max')) || 39.4;
    let numPanels = Math.ceil(totalWidth / maxPanelWidth);
    let panelWidthData = totalWidth / numPanels;
    if (panelWidthData < minPanelWidth) {
        numPanels = Math.ceil(totalWidth / minPanelWidth);
        panelWidthData = minPanelWidth;
    }
    panelWidthData = Math.round(panelWidthData * 100) / 100;
    $(panelWidth).val(panelWidthData);
    $(propertiesPanelWidth).val(panelWidthData+' inches');
    $(panelWidthValue).text(panelWidthData + ' inches');
}




$('#show_ruler').click(function () {
    if (!cropper) {
        console.warn('Ruler: cropper not ready yet');
        return;
    }
    $('#product_image').toggleClass('ruler-active');
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
        setTimeout(function() {
            canvasRulerInit();
        }, 100);
    }
});

// When button is clicked
$('#show_lengths').click(function () {
  $(this).toggleClass('active');

  // Toggle input state
  switch_input.checked = $(this).hasClass('active');

  // Trigger the switch change logic (to keep everything in sync)
  switch_input.dispatchEvent(new Event('change'));
});


$('#flip').click(function () {
  $(this).toggleClass('active');      
  if ($(this).hasClass('active')) {
    cropper.scaleX(-1); // horizontal flip
    $('#properties-flip').val('true');
  } else {
    cropper.scaleX(1);  // reset flip
    $('#properties-flip').val('false');
  }
});

$('.material-js').click(function () {
  $(this).toggleClass('active');
  if ($(this).hasClass('active')) {
    $('.popup').attr('data','material');
    $('.popup__overlay').addClass('open');
  } else {
    $('.popup').removeAttr('data');
    $('.popup__overlay').removeClass('open');
  }
  changeTheDimensions();
});


$('.dimensions-js').click(function () {
  $(this).toggleClass('active');
  if ($(this).hasClass('active')) {
    $('.popup').attr('data','dimensions');
    $('.popup__overlay').addClass('open');
  } else {
    $('.popup').removeAttr('data');
    $('.popup__overlay').removeClass('open');
  }
  changeTheDimensions();
});



$('.popup__overlay').click(function () {
  $('.dimensions-js').removeClass('active');
  $('.material-js').removeClass('active');
  $('.popup').removeAttr('data');
  $('.popup__overlay').removeClass('open');
    changeTheDimensions();
});

$(document).on("click", ".walltool-mobile-toolbar-cart-button", function () {
    $("#ms_sp_addto_cart").trigger("click");
});

// new js code



var canvasRulerInitTimer = null;
function canvasRulerInit() {
    clearTimeout(canvasRulerInitTimer);
    canvasRulerInitTimer = setTimeout(function() {
        _canvasRulerInitRun();
    }, 80);
}
function createRuler(lengthInInches, elementId, pxPerInch = 5, orientation = "horizontal", labelStep) {
  const container = document.querySelector(elementId);
  if (!container) {
    console.error("Container not found:", elementId);
    return;
  }

  const dpr = window.devicePixelRatio || 1;

  const existingCanvas = container.querySelector("canvas");
  if (existingCanvas) existingCanvas.remove();

  const canvas = document.createElement("canvas");
  const isHorizontal = orientation === "horizontal";

  let cssWidth, cssHeight;
  if (isHorizontal) {
    cssWidth = lengthInInches * pxPerInch;
    cssHeight = 30;
  } else {
    cssWidth = 30;
    cssHeight = lengthInInches * pxPerInch;
  }

  canvas.width = cssWidth * dpr;
  canvas.height = cssHeight * dpr;

  container.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  ctx.font = "14px Open Sans,sans-serif";
  ctx.fillStyle = "#717070db";
  ctx.strokeStyle = "#717070db";

  if (isHorizontal) {
    const baseY = cssHeight;
    for (let i = 0; i <= lengthInInches; i++) {
      const x = i * pxPerInch;
      const feet = i / 12;
      if (i % 12 === 0) {
        ctx.beginPath();
        if (i === 0) { ctx.moveTo(x + 2, baseY); ctx.lineTo(x + 2, baseY - 12); }
        else if (i === lengthInInches) { ctx.moveTo(x - 2, baseY); ctx.lineTo(x - 2, baseY - 12); }
        else { ctx.moveTo(x, baseY); ctx.lineTo(x, baseY - 12); }
        ctx.lineWidth = 2;
        ctx.stroke();
        if (feet % labelStep === 0) {
          ctx.textAlign = "center";
          if (i === 0) ctx.textAlign = "left";
          if (i === lengthInInches) ctx.textAlign = "right";
          ctx.fillText(`${feet}ft`, x, baseY - 17);
        }
      } else if (i % 6 === 0) {
        ctx.beginPath(); ctx.moveTo(x, baseY); ctx.lineTo(x, baseY - 10); ctx.lineWidth = 1; ctx.stroke();
      } else {
        ctx.beginPath(); ctx.moveTo(x, baseY); ctx.lineTo(x, baseY - 8); ctx.lineWidth = 1; ctx.stroke();
      }
    }
  } else {
    const baseX = cssWidth - 1;
    for (let i = 0; i <= lengthInInches; i++) {
      const y = cssHeight - (i * pxPerInch);
      const feet = i / 12;
      if (i % 12 === 0) {
        ctx.beginPath(); ctx.moveTo(baseX, y); ctx.lineTo(baseX - 12, y); ctx.lineWidth = 2; ctx.stroke();
        if (feet % labelStep === 0) {
          ctx.save();
          ctx.translate(12, y);
          ctx.rotate(-Math.PI / 2);
          ctx.textAlign = "center";
          if (i === 0) ctx.fillText(`${feet}ft`, 12, 0);
          else if (i === lengthInInches) ctx.fillText(`${feet}ft`, -14, 0);
          else ctx.fillText(`${feet}ft`, 0, 0);
          ctx.restore();
        }
      } else if (i % 6 === 0) {
        ctx.beginPath(); ctx.moveTo(baseX, y); ctx.lineTo(baseX - 10, y); ctx.lineWidth = 1; ctx.stroke();
      } else {
        ctx.beginPath(); ctx.moveTo(baseX, y); ctx.lineTo(baseX - 8, y); ctx.lineWidth = 1; ctx.stroke();
      }
    }
  }
}

function createRulerMeters(lengthInInches, elementId, pxPerInch = 5, orientation = "horizontal", labelStep, lengthInCm) {
  const container = document.querySelector(elementId);
  if (!container) {
    console.error("Container not found:", elementId);
    return;
  }

  const dpr = window.devicePixelRatio || 1;

  const existingCanvas = container.querySelector("canvas");
  if (existingCanvas) existingCanvas.remove();

  const canvas = document.createElement("canvas");
  const isHorizontal = orientation === "horizontal";

  let cssWidth, cssHeight;
  if (isHorizontal) {
    cssWidth = lengthInInches * pxPerInch;
    cssHeight = 30;
  } else {
    cssWidth = 30;
    cssHeight = lengthInInches * pxPerInch;
  }

  canvas.width = cssWidth * dpr;
  canvas.height = cssHeight * dpr;

  container.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  ctx.font = "14px Open Sans,sans-serif";
  ctx.fillStyle = "#717070db";
  ctx.strokeStyle = "#717070db";

  if (isHorizontal) {
    const baseY = cssHeight;
    for (let cm = 0; cm <= lengthInCm; cm++) {
      const x = (cm / 2.54) * pxPerInch;
      const meters = cm / 100;
      if (cm % 100 === 0) {
        ctx.beginPath();
        if (cm === 0) { ctx.moveTo(x + 2, baseY); ctx.lineTo(x + 2, baseY - 12); }
        else if (Math.abs(cm - lengthInCm) < 1) { ctx.moveTo(x - 4, baseY); ctx.lineTo(x - 4, baseY - 12); }
        else { ctx.moveTo(x, baseY); ctx.lineTo(x, baseY - 12); }
        ctx.lineWidth = 2; ctx.stroke();
        if (meters % labelStep === 0) {
          ctx.textAlign = "center";
          if (cm === 0) ctx.fillText(`${meters}m`, x + 12, baseY - 15);
          else if (Math.abs(cm - lengthInCm) < 1) ctx.fillText(`${meters}m`, x - 12, baseY - 18);
          else ctx.fillText(`${meters}m`, x, baseY - 15);
        }
      } else if (cm % 50 === 0) {
        ctx.beginPath(); ctx.moveTo(x, baseY); ctx.lineTo(x, baseY - 10); ctx.lineWidth = 1; ctx.stroke();
      } else if (cm % 10 === 0) {
        ctx.beginPath(); ctx.moveTo(x, baseY); ctx.lineTo(x, baseY - 8); ctx.lineWidth = 1; ctx.stroke();
      }
    }
  } else {
    const baseX = cssWidth - 1;
    for (let cm = 0; cm <= lengthInCm; cm++) {
      const y = cssHeight - (cm / 2.54) * pxPerInch;
      const meters = cm / 100;
      if (cm % 100 === 0) {
        ctx.beginPath();
        if (cm === 0) { ctx.moveTo(baseX, y - 2); ctx.lineTo(baseX - 12, y - 2); }
        else if (Math.abs(cm - lengthInCm) < 1) { ctx.moveTo(baseX, y + 4); ctx.lineTo(baseX - 12, y + 4); }
        else { ctx.moveTo(baseX, y); ctx.lineTo(baseX - 12, y); }
        ctx.lineWidth = 2; ctx.stroke();
        if (meters % labelStep === 0) {
          ctx.save();
          ctx.translate(12, y);
          ctx.rotate(-Math.PI / 2);
          ctx.textAlign = "center";
          if (cm === 0) ctx.fillText(`${meters}m`, 12, 0);
          else if (Math.abs(cm - lengthInCm) < 1) ctx.fillText(`${meters}m`, -14, 0);
          else ctx.fillText(`${meters}m`, 0, 0);
          ctx.restore();
        }
      } else if (cm % 50 === 0) {
        ctx.beginPath(); ctx.moveTo(baseX, y); ctx.lineTo(baseX - 10, y); ctx.lineWidth = 1; ctx.stroke();
      } else if (cm % 10 === 0) {
        ctx.beginPath(); ctx.moveTo(baseX, y); ctx.lineTo(baseX - 8, y); ctx.lineWidth = 1; ctx.stroke();
      }
    }
  }
}

function _canvasRulerInitRun() {
  const unit = $('.unit-selector:not(.read-select)').first().val() || $('.unit-selector').val();
  // ✅ Always read from the hidden source-of-truth fields (total inches)
  var widthInches  = parseInt($('#width_in_inches').val(),  10) || 0;
  var heightInches = parseInt($('#height_in_inches').val(), 10) || 0;

  // ✅ Build correct display label based on unit
  let widthLabel, heightLabel;
  if (unit === 'ft/in') {
    const wFt = Math.floor(widthInches  / 12);
    const wIn = parseFloat((widthInches  % 12).toFixed(2));
    const hFt = Math.floor(heightInches / 12);
    const hIn = parseFloat((heightInches % 12).toFixed(2));
    widthLabel  = wIn > 0 ? `${wFt} ft ${wIn} in` : `${wFt} ft`;
    heightLabel = hIn > 0 ? `${hFt} ft ${hIn} in` : `${hFt} ft`;
    } else if (unit === 'cm') {
        // ✅ Read directly from input to avoid inch conversion precision loss
        const wCm = parseFloat($('#width_in_inches_input').val())  || 0;
        const hCm = parseFloat($('#height_in_inches_input').val()) || 0;
        widthLabel  = wCm  + ' cm';
        heightLabel = hCm + ' cm';
      } else if (unit === 'm') {
        const wM = parseFloat($('#width_in_inches_input').val())  || 0;
        const hM = parseFloat($('#height_in_inches_input').val()) || 0;
        widthLabel  = wM  + ' m';
        heightLabel = hM + ' m';
      } else {
        widthLabel  = widthInches  + ' in';
        heightLabel = heightInches + ' in';
      }

  $('.walltool-canvas-width span').text(widthLabel);
  $('.walltool-canvas-height span').text(heightLabel);
  $('.sixe__info').text(`${widthLabel} x ${heightLabel}`);

  let chartWidth  = $('.cropper-dashed.dashed-v').outerWidth()  || 0;
  let chartHeight = $('.cropper-dashed.dashed-h').outerHeight() || 0;

  // Guard: retry if cropper not sized yet
  if (chartWidth <= 0 || chartHeight <= 0) {
    setTimeout(canvasRulerInit, 200);
    return;
  }

  const pxPerInchX = widthInches  > 0 ? chartWidth  / widthInches  : 0;
  const pxPerInchY = heightInches > 0 ? chartHeight / heightInches : 0;

  var labelStep = 1;

  if (unit === 'inch' || unit === 'ft' || unit === 'ft/in') {

    var totalFeetH = heightInches / 12;
    labelStep = 1;
    if (pxPerInchY < 2.8) labelStep = 2;
    if (pxPerInchY < 1.6) labelStep = 5;
    if (totalFeetH > 25)  labelStep = 5;
    createRuler(heightInches, ".cropper-dashed.dashed-h", pxPerInchY, "vertical", labelStep);

    var totalFeetW = widthInches / 12;
    labelStep = 1;
    if (pxPerInchX < 2.8) labelStep = 2;
    if (pxPerInchX < 1.6) labelStep = 5;
    if (totalFeetW > 20)  labelStep = 5;
    createRuler(widthInches, ".cropper-dashed.dashed-v", pxPerInchX, "horizontal", labelStep);

  } else {

    var widthInCm  = parseFloat($('#width_in_inches_input').val())  || 0;
    var heightInCm = parseFloat($('#height_in_inches_input').val()) || 0;
    if (unit === 'm') {
      widthInCm  *= 100;
      heightInCm *= 100;
    }

    labelStep = 1;
    if ((widthInCm / 100) > 10) labelStep = 2;
    createRulerMeters(widthInches,  ".cropper-dashed.dashed-v", pxPerInchX, "horizontal", labelStep, widthInCm);

    labelStep = 1;
    if ((heightInCm / 100) > 10) labelStep = 2;
    createRulerMeters(heightInches, ".cropper-dashed.dashed-h", pxPerInchY, "vertical",   labelStep, heightInCm);
  }
}
function updateAddToCartButtonState() {
    if (areDimensionsFilled()) {
        if (addToCart.innerHTML === ADD_TO_CART_EMPTY_TEXT) {
            addToCart.innerHTML = addToCartOriginalHTML;
            changeTheDimensions();
        }
    } else {
        addToCart.disabled = true;
        addToCart.innerHTML = ADD_TO_CART_EMPTY_TEXT;
    }
}
function areDimensionsFilled() {
    const unit = $(".unit-selector:not(.read-select)").first().val();

    if (unit === "ft/in") {
        var wFt = $("#width_in_inches_input").val() || $("#preview_width_ft").val();
        var wIn = $("#width_in").val()              || $("#preview_width_in").val();
        var hFt = $("#height_in_inches_input").val()|| $("#preview_height_ft").val();
        var hIn = $("#height_in").val()             || $("#preview_height_in").val();

        var widthFilled  = (wFt !== "" && wFt !== undefined) || (wIn !== "" && wIn !== undefined);
        var heightFilled = (hFt !== "" && hFt !== undefined) || (hIn !== "" && hIn !== undefined);
        return widthFilled && heightFilled;
    } else {
        var w = $("#width_in_inches_input").val() || $("#preview_width_ft").val();
        var h = $("#height_in_inches_input").val() || $("#preview_height_ft").val();
        return (w !== "" && w !== undefined) && (h !== "" && h !== undefined);
    }
}
function showEmptyDimensionsAlert() {
    $('.walltool-dimensions-required-alert').css('display', 'flex');
}
function hideEmptyDimensionsAlert() {
    $('.walltool-dimensions-required-alert').css('display', 'none');
}

$("#width_in_inches_input, #width_in, #height_in_inches_input, #height_in, #preview_width_ft, #preview_width_in, #preview_height_ft, #preview_height_in").on("input", function () {
  dimensionsUserInteracted = true;
  updateAddToCartButtonState();
    if (areDimensionsFilled()) {
        hideEmptyDimensionsAlert();
    } else {
        showEmptyDimensionsAlert();
    }
});